"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import HoverableValue from "./hoverable_value";
function showValue(props, item) {
  if (item.hoverable) {
    return /* @__PURE__ */ jsx(
      HoverableValue,
      {
        value: item.value,
        onValueHighlighted: props.onValueHighlighted,
        onValueClick: props.onValueClick
      }
    );
  } else {
    const value = item.value;
    return /* @__PURE__ */ jsx("span", { className: "hoverable-value-table__value", children: value });
  }
}
function HoverableValueTable(props) {
  return /* @__PURE__ */ jsx(
    "table",
    {
      "data-component": "HoverableValueTable",
      className: "load-detail__info-table load-detail__info-table--vertical",
      children: /* @__PURE__ */ jsx("tbody", { children: _.map(props.items, (item, index) => /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("th", { children: item.name }),
        /* @__PURE__ */ jsx("td", { children: showValue(props, item) })
      ] }, "reference_row_" + index)) })
    }
  );
}
export default HoverableValueTable;
